import script from "./btn-common.vue?vue&type=script&setup=true&lang=js"
export * from "./btn-common.vue?vue&type=script&setup=true&lang=js"

import "./btn-common.vue?vue&type=style&index=0&id=7e524368&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e524368"]])

export default __exports__